import { Entity } from "@/enums";

export const baseUrl = {
  [Entity.PRODUCT]: `${process.env.REACT_APP_REST_BASE_URL}/products`,
  [Entity.SUPPLIER]: `${process.env.REACT_APP_REST_BASE_URL}/supplier`,
  [Entity.BARCODE]: `${process.env.REACT_APP_REST_BASE_URL}/barcodes`,
  [Entity.PRODUCT_TYPE]: `${process.env.REACT_APP_REST_BASE_URL}/producttype`,
  [Entity.BLOB_STORAGE]: `${process.env.REACT_APP_REST_BASE_URL}/blobs`,
  [Entity.DOCUMENT]: `${process.env.REACT_APP_REST_BASE_URL}/documents`,
  [Entity.DEALER]: `${process.env.REACT_APP_REST_BASE_URL}/dealers`,
  [Entity.DEALER_DEALER_MASTER_DEALER]: `${process.env.REACT_APP_REST_BASE_URL}/dealerdealermasterdealers`,
  [Entity.SETTING]: `${process.env.REACT_APP_REST_BASE_URL}/settings`,
  [Entity.EMAIL]: `${process.env.REACT_APP_REST_BASE_URL}/emails`,
  [Entity.TEMPLATE]: `${process.env.REACT_APP_REST_BASE_URL}/templates`,
  [Entity.ORDER]: `${process.env.REACT_APP_REST_BASE_URL}/orders`,
  [Entity.INVENTORY_COUNTS]: `${process.env.REACT_APP_REST_BASE_URL}/inventorycounts`,
  [Entity.FedEx]: `${process.env.REACT_APP_REST_BASE_URL}/FedEx`,
  [Entity.PRODUCT_AUDIT]: `${process.env.REACT_APP_REST_BASE_URL}/ProductAudit`,
};
